import React, { useEffect } from "react";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import { connect } from "react-redux";
import Panel from "Portal/NewPortal/Shared/Panel";
import { FontIcon, Div } from "components/Base";

// import * as FIELD_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-module-field-ids";

import {
  getSectionHeaderColor,
  getSectionHeaderFont,
  getSectionHeaderSize,
  getSectionIconById,
  getShouldShowSessions,
  getVisibleSessionFieldIds
} from "Portal/NewPortal/PortalHome/selectors";

import * as PortalSelectors from "redux/modules/portal/selectors";

import Tabs from "ui-kit/Tabs/View";

import {
  filteredTasks,
  getFilteredSessionsTasks,
  getTabs,
  getTotalTaskCount
} from "../selectors";
import { actions } from "../model";
import {
  HOME_TASK_CARD_TABS_INSTANCE_ID,
  MY_SESSION_TASKS_TOOLTIP,
  MY_ALL_TASKS_TOOLTIP,
  TABS
} from "../constants";
import Task from "./Task";
import FilterBy from "./FilterBy";
import MobileFilterBy from "./MobileFilterBy";

import styles from "./styles.scss";

// import { noop } from "utils/General";

import { actions as PortalHomeActions } from "Portal/NewPortal/PortalHome/model";

// import { SECTIONS_IDS } from "Portal/NewPortal/PortalHome/constants";

import { useMobile } from "Portal/NewPortal/Shared/UseMobile";

import useDisplay from "Portal/NewPortal/Shared/useDisplay";

import { getDateLabel } from "../utils";

import { getters as TabGetters } from "ui-kit/Tabs";

const decorate = R.compose(
  connect(
    state => ({
      totalTaskCount: getTotalTaskCount(state),
      tasks: filteredTasks(state),
      sessionsTasks: getFilteredSessionsTasks(state),
      sectionHeaderColor: getSectionHeaderColor(state),
      sectionHeaderFont: getSectionHeaderFont(state),
      sectionHeaderSize: getSectionHeaderSize(state),
      portal: PortalSelectors.portal(state),
      tabs: getTabs(state),
      selectedTab: TabGetters.selectedTab(state, {
        instanceId: HOME_TASK_CARD_TABS_INSTANCE_ID
      }),
      visibleSessionFieldIds: getVisibleSessionFieldIds(state),
      shouldShowSessions: getShouldShowSessions(state)
    }),
    {
      init: actions.init,
      onClickPanelHeader: PortalHomeActions.setSelectedCategory
    }
  ),
  CSSModules(styles)
);

const MyTasksHeader = ({ title = "My Tasks", tooltip = null }) => {
  return (
    <div className={styles.myTasksHeaderSubContainer}>
      <div className={styles.myTasksHeader}>
        <div className={styles.myTasksTitle}>{title}</div>
        <FontIcon
          color="#666666"
          fs={3}
          from="material-icons-outlined"
          tooltip={tooltip}
        >
          info
        </FontIcon>
      </div>
    </div>
  );
};

// eslint-disable-next-line no-unused-vars
const SessionHeader = ({
  friendly_id,
  name,
  starts_at,
  ends_at,
  location,
  timezone,
  status
  // visibleSessionFieldIds
}) => {
  const display = useDisplay();
  const date = getDateLabel({
    startsAt: starts_at,
    endsAt: ends_at,
    timezone
  });

  const isApproved = ["complete", "accepted"].includes(status);

  return (
    <Div display={display} className={styles.sessionTasksSubContainer}>
      {/* {visibleSessionFieldIds.includes(FIELD_IDS.SESSIONS.FRIENDLY_ID) ? (
        <div className={[styles.friendlyId, "accentable-text"].join(" ")}>
          {friendly_id}
        </div>
      ) : null} */}
      <div
        className={[
          styles.friendlyId,
          "accentable-text",
          "tasks--session-header--friendly-id"
        ].join(" ")}
      >
        {friendly_id}
      </div>
      <div className={styles.taskName}>{name}</div>
      {isApproved && (
        <div className={styles.taskDetails}>
          {date}
          {location && location.length ? <> | {location}</> : null}
        </div>
      )}
    </Div>
  );
};

const Tasks = ({
  tasks = [],
  sessionsTasks = [],
  init,
  tabs = [],
  // onClickPanelHeader = noop,
  totalTaskCount,
  portal,
  selectedTab,
  visibleSessionFieldIds,
  shouldShowSessions
}) => {
  const isMobile = useMobile();
  useEffect(() => {
    init();
  }, []);
  const icon = getSectionIconById("tasks") || null;
  const timezone = R.path(["event", "timezone"])(portal);

  return (
    <Panel
      title={"Tasks"}
      length={totalTaskCount}
      panelContainerStyle={{
        maxHeight: "400px",
        height: "400px",
        overflow: "auto",
        padding: "20px"
      }}
      icon={icon}
      // onClickHeader={() => onClickPanelHeader({ category: SECTIONS_IDS.TASKS })}
    >
      <Div display="column.flex-start.flex-start" style={{ gap: "20px" }}>
        <Div
          width={1}
          bb={1}
          bc="#E7E6EA"
          display="row.space-between.flex-start"
        >
          <Tabs
            instanceId={HOME_TASK_CARD_TABS_INSTANCE_ID}
            tabs={tabs}
            tabStyle={{
              className: "accentable-tab",
              fs: 3,
              ...(isMobile && {
                style: {
                  flex: "1 0 160px"
                }
              })
            }}
          ></Tabs>

          {!isMobile && <FilterBy />}
        </Div>

        {isMobile && <MobileFilterBy />}

        {shouldShowSessions &&
        R.contains(selectedTab, [TABS.ALL, TABS.SESSION]) ? (
          <div styleName="tasksContainer">
            <div styleName="tasksHeaderContainer">
              <MyTasksHeader
                title="Session Tasks"
                tooltip={MY_SESSION_TASKS_TOOLTIP}
              />
            </div>

            {R.length(sessionsTasks) > 0
              ? R.map(
                  session => (
                    <Div
                      display="column.flex-start.flex-start"
                      style={{ gap: "12px" }}
                    >
                      <SessionHeader
                        key={session.id}
                        timezone={timezone}
                        visibleSessionFieldIds={visibleSessionFieldIds}
                        {...session}
                      />
                      {R.map(task => {
                        return (
                          <Task
                            key={task.id}
                            data={task}
                            sessionId={session.id}
                          />
                        );
                      }, session.tasks)}
                    </Div>
                  ),
                  sessionsTasks
                )
              : "No session tasks found"}
          </div>
        ) : null}

        {R.contains(selectedTab, [TABS.ALL, TABS.CONTACT]) && (
          <div styleName="tasksContainer">
            <div styleName="tasksHeaderContainer">
              <MyTasksHeader title="My Tasks" tooltip={MY_ALL_TASKS_TOOLTIP} />
            </div>
            {R.length(tasks) > 0
              ? R.map(task => {
                  return <Task key={task.id} data={task} />;
                }, tasks)
              : "No tasks found"}
          </div>
        )}
      </Div>
    </Panel>
  );
};

export default decorate(Tasks);
